import { useState } from "react";
import { runQuery } from "../services/api";
import DataTable from "./DataTable";
import QueryCharts from "./QueryCharts";

const TABS = ["tablo", "grafik"];

export default function QueryEditor() {
  const [sql, setSql] = useState("SELECT TOP 100 * FROM ");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("tablo");

  const execute = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await runQuery(sql);
      setResult(res.data);
      setActiveTab("tablo");
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Editor */}
      <div style={{ marginBottom: 12 }}>
        <textarea
          value={sql}
          onChange={(e) => setSql(e.target.value)}
          rows={6}
          style={{
            width: "100%",
            background: "var(--bg-page)",
            color: "var(--text-primary)",
            border: "1px solid var(--border)",
            borderRadius: 8,
            padding: 12,
            fontSize: 14,
            fontFamily: "monospace",
            resize: "vertical",
            outline: "none",
            boxSizing: "border-box",
          }}
          onKeyDown={(e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === "Enter") execute();
          }}
          placeholder="SELECT TOP 100 * FROM [dbo].[tablo_adi]"
        />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8 }}>
          <span style={{ color: "var(--text-faint)", fontSize: 12 }}>Ctrl+Enter ile çalıştır — sadece SELECT sorgular</span>
          <button
            onClick={execute}
            disabled={loading}
            style={{
              padding: "8px 22px",
              borderRadius: 7,
              border: "none",
              background: loading ? "var(--border)" : "#2563eb",
              color: "#fff",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: 14,
            }}
          >
            {loading ? "Çalışıyor..." : "▶  Çalıştır"}
          </button>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div
          style={{
            background: "#450a0a",
            border: "1px solid #7f1d1d",
            borderRadius: 8,
            padding: "12px 16px",
            color: "#fca5a5",
            fontSize: 13,
            marginBottom: 12,
          }}
        >
          {error}
        </div>
      )}

      {/* Results */}
      {result && (
        <div>
          {/* Meta + Tabs */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid var(--border)",
              marginBottom: 0,
            }}
          >
            <span style={{ color: "var(--text-muted)", fontSize: 13 }}>
              {result.row_count} satır · {result.columns.length} kolon
            </span>
            <div style={{ display: "flex", gap: 0 }}>
              {TABS.map((t) => (
                <button
                  key={t}
                  onClick={() => setActiveTab(t)}
                  style={{
                    padding: "8px 18px",
                    background: "transparent",
                    border: "none",
                    borderBottom: activeTab === t ? "2px solid var(--accent)" : "2px solid transparent",
                    color: activeTab === t ? "var(--accent)" : "var(--text-muted)",
                    cursor: "pointer",
                    fontWeight: activeTab === t ? 600 : 400,
                    fontSize: 14,
                    textTransform: "capitalize",
                  }}
                >
                  {t === "tablo" ? "📋 Tablo" : "📊 Grafik"}
                </button>
              ))}
            </div>
          </div>

          <div style={{ paddingTop: 16 }}>
            {activeTab === "tablo" && (
              <DataTable
                columns={result.columns}
                rows={result.rows}
                total={result.row_count}
                limit={result.row_count}
                offset={0}
              />
            )}
            {activeTab === "grafik" && (
              <QueryCharts columns={result.columns} rows={result.rows} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
